import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectDoesUserHaveRole } from '@backrs_ui/grow-ui/src/redux/user/user';
import { ENVIRONMENT } from '@backrs_ui/grow-ui/src/settings';

/**
 * Use this hook to hide specific pages to just local/dev/staging and users who are Lubav Beta in prod
 */
export const useRedirectIfNotAuthorized = () => {
  const navigate = useNavigate();

  const hasRole = useAppSelector(selectDoesUserHaveRole('Lubav Beta'));
  const isLoggedInUser = useAppSelector((state) => state.user.user);

  const canAccess = ENVIRONMENT !== 'production' || hasRole;

  useEffect(() => {
    if (!canAccess) {
      navigate(isLoggedInUser ? APP_ROUTE.HOME : APP_ROUTE.LOGIN);
    }
  }, [canAccess, navigate, isLoggedInUser]);
};
